/**
 * Alert Popup Flag
 *
 * @category Configuration
 * @type {string}
 */
export const ALERT_POPUP_FLAG = `${process.env.REACT_APP_ALERT_POPUP_FLAG}`;